import store from '../store';

export default async function entryValuationReport({ next, router }) {

    store.commit('SET_PRODUCT_TYPE', 'EntryValuationReport');

    if (store.getters.isAuthenticated)
        return router.push({ name: "CreateReportFormat", params: { report: 'valuation' } });
    else
        return router.push({ name: "Login" });


    return next();
}
